import React from "react"
import { Row, Col } from "react-bootstrap"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import * as style from "../Supporters.module.css"

import AvistaLogo from "../AvistaLogo"

import IdahoPowerLogo from '../IdahoPowerLogo'
import BuckKnivesLogo from "../BuckKnivesLogo"
import LitehouseFoodsLogo from "../LitehouseFoodsLogo"


const SilverLevel = () => {
    const data = useStaticQuery(graphql`
    {
      vChocolates: file(relativePath: { eq: "Vlogo_No_Background.png" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 80) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      olympicSteel: file(relativePath: { eq: "olympic-steel-logo.png" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 80) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      riverClub: file(relativePath: { eq: "river-club-logo.png" }) {
        childImageSharp {
          fluid(maxWidth: 100, quality: 90) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      signCenter: file(relativePath: { eq: "sign-center.png" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 80) {
            ...GatsbyImageSharpFluid
          }
        }
      }
        generalDynamics: file(relativePath: { eq: "GeneralDynamicsMissionSystems.png" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 80) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      spubBrew: file(relativePath: { eq: "spud-brew.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 80) {
            ...GatsbyImageSharpFluid
          }
        }
      }
        outerlightBrewing: file(relativePath: { eq: "outer-light-brewing.png" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 80) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
      <div>
      <hr />
        <div className={style.stickyHeader} style={{ zIndex: 52 }}><h1 className="text-center">Silver Level Corporate Donors - $10,000+</h1></div>
        
    <Row className={`${style.silverLevel} my-4`}>

      <Col lg={6} xl={4} mb={2}>
        <Row style={{alignItems: 'center', height: '100%'}}>
      <Col md={4} className="text-center">
        <AvistaLogo fillColor="#003767"/>
        <p className="text-center mt-2" style={{fontSize: 'small', color: 'gray'}}>Click logo to visit partner website.</p>
      </Col>
      <Col md={8}>
        <h2>Avista Corp.</h2>        
      </Col>
      </Row>
      </Col>

      <Col lg={6} xl={4} mb={2}>
        <Row style={{alignItems: 'center', height: '100%'}}>
      <Col md={4} className="text-center">
        <BuckKnivesLogo />
        <p className="text-center mt-2" style={{fontSize: 'small', color: 'gray'}}>Click logo to visit partner website.</p>
      </Col>
      <Col md={8}>
        <h2>Buck Knives</h2>        
      </Col>
      </Row>
      </Col>

      <Col lg={6} xl={4} mb={2}>
        <Row style={{alignItems: 'center', height: '100%'}}>
      <Col md={4} className="text-center">
      <LitehouseFoodsLogo />
        <p className="text-center mt-2" style={{fontSize: 'small', color: 'gray'}}>Click logo to visit partner website.</p>
      </Col>
      <Col md={8}>
        <h2>Litehouse Foods</h2>
      </Col>
      </Row>
      </Col>

      <Col lg={6} xl={4} mb={2}>
        <Row style={{alignItems: 'center', height: '100%'}}>
        <Col md={4} className="text-center">
      <a href="https://www.olysteel.com" target="_blank" rel="noopener noreferrer"><Img fluid={data.olympicSteel.childImageSharp.fluid} alt="Olympic Steel logo" /></a>
        <p className="text-center mt-2" style={{fontSize: 'small', color: 'gray'}}>Click logo to visit partner website.</p>
      </Col>
      <Col md={8}>
        <h2>Olympic Steel</h2>        
      </Col>
      </Row>
      </Col>
      <Col lg={6} xl={4} mb={2}>
      <Row style={{alignItems: 'center', height: '100%'}}>
        <Col md={4} className="text-center">
              <a href="https://signcenter.com" target="_blank" rel="noopener noreferrer">
              <Img
                fluid={data.signCenter.childImageSharp.fluid}
                alt="Sign Center Logo"
                style={{ maxWidth: "162px" }}
              />
               <p className="text-center mt-2" style={{fontSize: 'small', color: 'gray'}}>Click logo to visit partner website.</p>
              </a>
            </Col>
        
            <Col md={8}>
              <h2>Sign Center</h2>
            </Col>
          </Row> 
        </Col> 
        <Col lg={6} xl={4} mb={2}>
          <Row style={{alignItems: 'center', height: '100%'}}>
          <Col md={4} className="text-center">
                <a href="https://www.riverclubboise.com/" target="_blank" rel="noopener noreferrer">
                <Img
                  fluid={data.riverClub.childImageSharp.fluid}
                  alt="Infinity Signs Logo"
                  style={{ maxWidth: "162px" }}
                />
                 <p className="text-center mt-2" style={{fontSize: 'small', color: 'gray'}}>Click logo to visit partner website.</p>
                </a>
              </Col>
          
              <Col md={8} >
                <h2>River Club Boise</h2>
              </Col>
            </Row> 
          </Col>
          <Col lg={6} xl={4} mb={2}>
          <Row style={{alignItems: 'center', height: '100%'}}>
          <Col md={4} className="text-center">
                <a href="https://vchocolates.com/" target="_blank" rel="noopener noreferrer">
                <Img
                  fluid={data.vChocolates.childImageSharp.fluid}
                  alt="V Chocolates Logo"
                  style={{ maxWidth: "162px" }}
                />
                 <p className="text-center mt-2" style={{fontSize: 'small', color: 'gray'}}>Click logo to visit partner website.</p>
                </a>
              </Col>
          
              <Col md={8}>
                <h2>V Chocolates</h2>
              </Col>
            </Row> 
          </Col>
          <Col lg={6} xl={4} mb={2}>
          <Row style={{alignItems: 'center', height: '100%'}}>
          <Col md={12} className="text-center">
                <a href="https://gdmissionsystems.com/" target="_blank" rel="noopener noreferrer">
                <Img
                  fluid={data.generalDynamics.childImageSharp.fluid}
                  alt="General Dynamics Mission Systems Logo"
                  style={{ width: "80%" }}
                />
                 <p className="text-center mt-2" style={{fontSize: 'small', color: 'gray'}}>Click logo to visit partner website.</p>
                </a>
              </Col>
            </Row> 
          </Col>
          <Col lg={6} xl={4} mb={2}>
          <Row style={{alignItems: 'center', height: '100%'}}>
          <Col md={3} className="text-center">
                <a href="https://gdmissionsystems.com/" target="_blank" rel="noopener noreferrer">
                <Img
                  fluid={data.spubBrew.childImageSharp.fluid}
                  alt="Spud Brew Logo"
                  style={{ width: "100px" }}
                />
                 <p className="text-center mt-2" style={{fontSize: 'small', color: 'gray'}}>Click logo to visit partner website.</p>
                </a>
              </Col>
          
              <Col md={8}>
                <h2>North American Brewers</h2>
              </Col>
            </Row> 
          </Col>
          <Col lg={6} xl={4} mb={2}>
          <Row style={{alignItems: 'center', height: '100%'}}>
          <Col md={3} className="text-center">
                <a href="https://outerlightbrewing.com/" target="_blank" rel="noopener noreferrer">
                <Img
                  fluid={data.outerlightBrewing.childImageSharp.fluid}
                  alt="Outer Light Brewing Logo"
                  style={{ width: "100px" }}
                />
                 <p className="text-center mt-2" style={{fontSize: 'small', color: 'gray'}}>Click logo to visit partner website.</p>
                </a>
              </Col>
              <Col md={8}>
                <h2>Outer Light Brewing</h2>
              </Col>
            </Row> 
          </Col>
    </Row>
  </div>
  )
}

export default SilverLevel
